require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-why-we-added-reactjs-to-our-javascript-development-accelerator-curriculum.json") })
        }
      }, "path---blog-why-we-added-reactjs-to-our-javascript-development-accelerator-curriculum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-why-we-added-reactjs-to-our-javascript-development-accelerator-curriculum!./.cache/json/blog-why-we-added-reactjs-to-our-javascript-development-accelerator-curriculum.json
// module id = 1154
// module chunks = 231608221292675